// @ts-nocheck
import { ConfigSectionModel, ConfigurationModel, SectionOptionModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";

const BASE_SECTION_OPTION_MAX_LENGTH = 40;

const isTrue = (value?: boolean | null) => value === true;

const configHasOnlyOptionalEmbroideries = (configuration: ConfigurationModel | null | undefined) =>
    isTrue(
        configuration &&
            configuration.configSections &&
            configuration.configSections.every(
                configSection =>
                    isConfigSectionEmbroidery(configSection) &&
                    hasNoSectionOptionRequired(configSection.sectionOptions),
            ),
    );

const isConfigSectionEmbroidery = (configSection: ConfigSectionModel | null | undefined) =>
    isTrue(
        configSection && configSection.sectionName.toLowerCase() === constants.productConfigurationSection.embroidery,
    );

const hasNoSectionOptionRequired = (sectionOptions: SectionOptionModel[] | null | undefined) =>
    isTrue(sectionOptions && sectionOptions.every(sectionOption => !isSectionOptionRequired(sectionOption)));

const isSectionOptionRequired = (sectionOption: SectionOptionModel | null | undefined) =>
    isTrue(sectionOption && "required" in sectionOption && sectionOption.required === true);

const getSectionOptionMaxLength = (sectionOption: SectionOptionModel | null | undefined) =>
    sectionOption && "maxLength" in sectionOption && typeof sectionOption.maxLength === "number"
        ? (sectionOption.maxLength as number)
        : BASE_SECTION_OPTION_MAX_LENGTH;

export {
    configHasOnlyOptionalEmbroideries, getSectionOptionMaxLength, hasNoSectionOptionRequired, isConfigSectionEmbroidery, isSectionOptionRequired
};

